import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_V2_URL } from 'on-common/constants';
import { IApiResult } from 'on-common/_models/ApiResult';
import {
    DuplicateSuspicion,
    DuplicateSuspicionStatus,
} from '../_models/DuplicateSuspicion';

const DUPLICATE_SUSPICION_URL = API_V2_URL + '/duplicate-suspicions';

@Injectable({
    providedIn: 'root',
})
export class DuplicateSuspicionService {
    constructor(private http: HttpClient) {}

    getByCompany(
        companyId: number,
        status?: DuplicateSuspicionStatus,
    ): Observable<IApiResult<DuplicateSuspicion[]>> {
        let url = `${DUPLICATE_SUSPICION_URL}/company/${companyId}`;
        if (status) {
            url += `?status=${status}`;
        }
        return this.http.get<IApiResult<DuplicateSuspicion[]>>(url);
    }

    getByReport(
        reportId: number,
    ): Observable<IApiResult<DuplicateSuspicion[]>> {
        return this.http.get<IApiResult<DuplicateSuspicion[]>>(
            `${DUPLICATE_SUSPICION_URL}/report/${reportId}`,
        );
    }

    getByExpense(
        expenseId: number,
    ): Observable<IApiResult<DuplicateSuspicion[]>> {
        return this.http.get<IApiResult<DuplicateSuspicion[]>>(
            `${DUPLICATE_SUSPICION_URL}/expense/${expenseId}`,
        );
    }

    hasDuplicates(expenseId: number): Observable<IApiResult<boolean>> {
        return this.http.get<IApiResult<boolean>>(
            `${DUPLICATE_SUSPICION_URL}/expense/${expenseId}/has-duplicates`,
        );
    }

    getPendingCountByExport(exportId: number): Observable<IApiResult<number>> {
        return this.http.get<IApiResult<number>>(
            `${DUPLICATE_SUSPICION_URL}/export/${exportId}/pending-count`,
        );
    }

    updateStatus(
        suspicionId: number,
        status: DuplicateSuspicionStatus,
    ): Observable<IApiResult<DuplicateSuspicion>> {
        return this.http.put<IApiResult<DuplicateSuspicion>>(
            `${DUPLICATE_SUSPICION_URL}/${suspicionId}`,
            { Status: status },
        );
    }
}
